(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLDetailsElement) || !target.open) return;
  if (target.classList.contains('theralica-desktop-dropdown')) {
    document.querySelectorAll('.theralica-desktop-dropdown[open]').forEach(item => {
      if (item !== target) item.open = false;
    });
  }
}, true);
document.addEventListener('click', (event) => {
  document.querySelectorAll('.theralica-desktop-dropdown[open]').forEach(item => {
    if (!item.contains(event.target)) item.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.theralica-desktop-dropdown[open],.theralica-mobile-menu[open]').forEach(item => {
    item.open = false;
    item.querySelector('summary')?.focus();
  });
});
  } catch(e) { console.error(e); }
})();

})();
